import PitchYawCameraController from './PitchYawCameraController';
import Event from '../utils/Event';

const DEFAULT_FOV = Math.PI / 4;
const DEFAULT_VELOCITY = Math.PI / 2;
const UP_KEY = 38;
const DOWN_KEY = 40;
const LEFT_KEY = 37;
const RIGHT_KEY = 39;

export default class KeyboardPanCameraController extends PitchYawCameraController {
    _frame: HTMLElement;
    _fov: number;
    _isUpPressed: boolean;
    _isDownPressed: boolean;
    _isRightPressed: boolean;
    _isLeftPressed: boolean;
    _handledEventEvent: Event;

    constructor({frame, fov, verticalBumper}) {
        super({
            verticalBumper,
            velocity: DEFAULT_VELOCITY,
            shouldHoldGaze: true,
            useRelativeRotation: true,
        });
        this._fov = fov || DEFAULT_FOV;
        this._frame = frame;
        this._isUpPressed = false;
        this._isDownPressed = false;
        this._isRightPressed = false;
        this._isLeftPressed = false;
        this._handledEventEvent = new Event();

        this._frame.addEventListener('keydown', (event) => this._onKeyDown(event));
        this._frame.addEventListener('keyup', (event) => this._onKeyUp(event));
    }

    enable() {
        super.enable();
        this._isUpPressed = false;
        this._isDownPressed = false;
        this._isRightPressed = false;
        this._isLeftPressed = false;
    }

    disable() {
        super.disable();
        this._isUpPressed = false;
        this._isDownPressed = false;
        this._isRightPressed = false;
        this._isLeftPressed = false;
    }

    subscribeHandledEvent(callback) {
        this._handledEventEvent.subscribe(callback);
    }

    unsubscribeHandledEvent(callback) {
        this._handledEventEvent.unsubscribe(callback);
    }

    _publishHandledEvent(eventArgs) {
        this._handledEventEvent.publish(this, eventArgs);
    }

    _onKeyDown(e) {
        let keyCode = e.keyCode;
        switch (keyCode) {
            case UP_KEY:
                this._publishHandledEvent(e);
                this._onUpPressed();
                break;
            case DOWN_KEY:
                this._publishHandledEvent(e);
                this._onDownPressed();
                break;
            case RIGHT_KEY:
                this._publishHandledEvent(e);
                this._onRightPressed();
                break;
            case LEFT_KEY:
                this._publishHandledEvent(e);
                this._onLeftPressed();
                break;
            default:
                // do nothing.
                break;
        }
    }

    _onKeyUp(e) {
        let keyCode = e.keyCode;
        switch (keyCode) {
            case UP_KEY:
                this._publishHandledEvent(e);
                this._onUpReleased();
                break;
            case DOWN_KEY:
                this._publishHandledEvent(e);
                this._onDownReleased();
                break;
            case RIGHT_KEY:
                this._publishHandledEvent(e);
                this._onRightReleased();
                break;
            case LEFT_KEY:
                this._publishHandledEvent(e);
                this._onLeftReleased();
                break;
            default:
                // do nothing.
                break;
        }
    }

    _onUpPressed() {
        this._isUpPressed = true;
        this._updatePitch();
    }

    _onDownPressed() {
        this._isDownPressed = true;
        this._updatePitch();
    }

    _onRightPressed() {
        this._isRightPressed = true;
        this._updateYaw();
    }

    _onLeftPressed() {
        this._isLeftPressed = true;
        this._updateYaw();
    }

    _onUpReleased() {
        this._isUpPressed = false;
        this._updatePitch();
    }

    _onDownReleased() {
        this._isDownPressed = false;
        this._updatePitch();
    }

    _onRightReleased() {
        this._isRightPressed = false;
        this._updateYaw();
    }

    _onLeftReleased() {
        this._isLeftPressed = false;
        this._updateYaw();
    }

    _updatePitch() {
        if (this._isUpPressed !== this._isDownPressed) {
            let pitch = DEFAULT_VELOCITY;
            if (this._isDownPressed) {
                pitch *= -1;
            }
            this.setPitch(pitch);
        } else {
            this.setPitch(0);
        }
    }

    _updateYaw() {
        if (this._isRightPressed !== this._isLeftPressed) {
            let yaw = DEFAULT_VELOCITY;
            if (this._isRightPressed) {
                yaw *= -1;
            }
            this.setYaw(yaw);
        } else {
            this.setYaw(0);
        }
    }
}
